import { Injectable } from '@angular/core';
import { ProductAnalyticsService } from '@usf/ngrx-product';
import { Product } from 'src/app/shared/models/product.model';
import { SearchAnalyticsService } from 'src/app/search/services/search-analytics.service';
@Injectable({
  providedIn: 'root',
})
export class DealsProductsAnalyticsService {
  constructor(
    private analyticsService: ProductAnalyticsService,
    private searchAnalyticsService: SearchAnalyticsService,
  ) {}

  trackLoadDealsPage(products: Product[]) {
    let productArr: Product[] = this.getProductsArray(products);
    this.analyticsService.trackAllDealsPageLoaded(productArr);
  }

  getProductsArray(products): any[] {
    let transformedProducts = [];
    const exceptionTrackingProducts =
      this.searchAnalyticsService.buildExceptionTrackingProducts(products);
    products.forEach(element => {
      const exceptionProduct = exceptionTrackingProducts?.find(
        p =>
          p.divisionApn ===
          element.summary.divisionNumber + '-' + element.summary.productNumber,
      );
      if (exceptionProduct) {
        transformedProducts.push({
          merchFeatureView: '1',
          merchFeatureName: 'deals',
          ...exceptionProduct,
        });
      } else {
        transformedProducts.push({
          merchFeatureView: '1',
          merchFeatureName: 'deals',
          attributes: element.trackingAttributes,
          divisionApn:
            element.summary.divisionNumber +
            '-' +
            element.summary.productNumber,
        });
      }
    });
    return transformedProducts;
  }
}
